import { UUID } from 'types'

import {
  PACKED_UUID_KEY,
  PackedUUIDs,
  packUuidList,
  unpackUuidList,
} from './packUuidList'

const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

const isUUIDArray = (arr: unknown[]): arr is UUID[] => {
  if (arr.length === 0) {
    return false
  }

  return arr.every(item => typeof item === 'string' && UUID_REGEX.test(item))
}

export const packState = (data: unknown): unknown => {
  if (Array.isArray(data)) {
    if (isUUIDArray(data)) {
      return packUuidList(data)
    }

    return data.map(packState)
  }

  if (data !== null && typeof data === 'object') {
    const result: Record<string, unknown> = {}

    for (const [key, value] of Object.entries(data)) {
      result[key] = packState(value)
    }

    return result
  }

  return data
}

export const unpackState = (data: unknown): unknown => {
  if (data !== null && typeof data === 'object' && PACKED_UUID_KEY in data) {
    return unpackUuidList(data as PackedUUIDs)
  }

  if (Array.isArray(data)) {
    return data.map(unpackState)
  }

  if (data !== null && typeof data === 'object') {
    const result: Record<string, unknown> = {}

    for (const [key, value] of Object.entries(data)) {
      result[key] = unpackState(value)
    }

    return result
  }

  return data
}
